import { GetRequest } from "./http/BaseRequest";
import { BaseResponse } from "./http/responses/BaseResponse";

export interface GetMinerNamesResponse extends BaseResponse {
  readonly Record: string[];
}

export class GetMinerNames extends GetRequest {
  constructor() {
    super("miner/names");
  }
}
